import { MenuActions } from '../../common/configuration/menu-actions';
import { DescrittoreSezione } from '../../common/models/descrittore-sezione';

export class CacheDescrittori {
  public idTipoPratica: any;
  public idTipoFascicolo: any;
  public azione: MenuActions;
  descrittoriMap: { [id: string]: DescrittoreSezione };

  constructor(idTipoPratica: any, idTipoFascicolo: any, azione: MenuActions, descrittoriMap: { [id: string]: DescrittoreSezione }) {
    this.idTipoPratica = idTipoPratica;
    this.idTipoFascicolo = idTipoFascicolo;
    this.azione = azione;
    this.descrittoriMap = descrittoriMap;
  }
}
